// @flow
import React, { Component } from 'react';
import styled from 'react-emotion';

/**
 * Styles
 */

const Layer = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: ${({ opacity }) => opacity};
  background-image: url('${({ src }) => src}');
  transition: opacity 0.5s;
`;

/**
 * Component: DoorLayer
 *
 * Image layer for door.
 */
export default class DoorLayer extends Component<
  { src?: string },
  { opacity: number }
> {
  state = {
    opacity: 0,
  };

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({
        opacity: 1,
      });
    }, 25);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  timeout /* : TimeoutID */;

  render() {
    const { src } = this.props;
    const { opacity } = this.state;
    return <Layer src={src} opacity={opacity} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/DoorLayer.js